unable to read source [project]/node_modules/stripe/src/resources/Tax/Settings.ts